// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper__3yBSz","large":"Tag_large__3uzlx"};